import React, { useRef, useState, useEffect } from 'react';
import styles from '../cpoi_pediatria/cpoi_pediatria.module.scss';
import Perfil from './src/perfil.png';
import TopLeftImage from './src/top-left.png';
import BottomLeftImage from './src/bottom-right.png';
import LinkPersonalizado2 from '../../components/LinkPersonalizado2/linkPersonalizado2.tsx';

const Cpoi_pediatria: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.cpoi_pediatria}>
            <div className={styles["body-thunder"]} style={{ height: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={styles["top-left-image-wrapper"]}>
                    <img
                        className={styles["top-left-image"]}
                        src={TopLeftImage}
                        alt="Top Left Image"
                    />
                </div>
                <div className={styles["bottom-right-image-wrapper"]}>
                    <img
                        className={styles["bottom-right-image"]}
                        src={BottomLeftImage}
                        alt="Bottom Right Image"
                    />
                </div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles["img-wrapper"]}>
                        <img
                            ref={imgRef}
                            className={styles["img-perfil"]}
                            src={Perfil}
                            alt="Profile Picture"
                        />
                    </div>
                    <h1 className="mt-4 mb-0">Centro de Pediatria</h1>
                    <h1 className="mb-2">Oncologia Integradas</h1>
                    <p className="mb-0">Horário de atendimento</p>
                    <p className="mb-6">Segunda à sexta, 14:00 às 18:00</p>
                    <div className={styles.links}>
                        <LinkPersonalizado2
                            href="https://wa.me/5517997341000?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20horário."
                            title="Agendamentos"
                            backgroundColor="#9aad97"
                            backgroundColorHover="#6c795f"
                            colorText="#FFF2DB"
                        />
                        <LinkPersonalizado2
                            href="https://www.instagram.com/cpoi.pediatria?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="Instagram"
                            backgroundColor="#9aad97"
                            backgroundColorHover="#6c795f"
                            colorText="#FFF2DB"
                        />
                        <LinkPersonalizado2
                            href="https://maps.app.goo.gl/eU8tipDWArTp3im4A"
                            title="Localização"
                            backgroundColor="#9aad97"
                            backgroundColorHover="#6c795f"
                            colorText="#FFF2DB"
                        />
                        <LinkPersonalizado2
                            href="https://clinicacpoi.com.br/"
                            title="Site"
                            backgroundColor="#9aad97"
                            backgroundColorHover="#6c795f"
                            colorText="#FFF2DB"
                        />
                        {/* <LinkPersonalizado2
                        href="https://clinicacpoi.com.br/"
                        title="Site"
                        backgroundColor="#9aad97"
                        backgroundColorHover="#6c795f"
                        colorText="#FFF2DB"
                    /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cpoi_pediatria;
